import {IMAGE_URL} from "../path";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import HeaderWhite from "../Components/Header/HeaderWhite";
import { useEffect, useState } from "react";

function Export() {
    const hero = IMAGE_URL + '/28-d.jpg';

    const [isAtTop, setIsAtTop] = useState(true);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleScroll = () => setIsAtTop(window.scrollY === 0);
        const handleResize = () => setWindowWidth(window.innerWidth);

        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleResize);
        handleScroll();

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const containerStyle: React.CSSProperties = {
        position: windowWidth > 768 ? 'relative' : 'static',
        left: windowWidth > 768 ? '50%' : 'auto',
        marginTop: '140px',
        width: windowWidth > 768 ? '50%' : '80%',
        textAlign: 'left',
        color: 'white',
        fontFamily: "'Vinimark-Diatype', sans-serif",
        display: 'flex',
        flexDirection: 'column',
        height: window.innerWidth > 835 ? '90%' : '70%',
        justifyContent: 'flex-end',
    };

    const textStyle: React.CSSProperties = {
        fontSize: '32px',
        fontWeight: 200,
        textTransform: "uppercase",
        marginBottom: '10px',
        paddingLeft: windowWidth > 835 ? '0' : '20px',
        marginLeft: windowWidth > 835 ? '26px' : 0
    };

    const linkStyleWhite: React.CSSProperties = {
        color: 'white',
        fontSize: '10px',
        lineHeight: '16.9px',
        marginBottom: windowWidth > 835 ? '112px' : '30px',
        cursor: 'pointer',
        textDecoration: 'underline',
        textUnderlineOffset: '2px',
        display: 'inline-block',             // keep element tight around text
        textTransform: 'uppercase',
        fontWeight: 600,
        marginLeft: '26px',

    };

    const linkStyle: React.CSSProperties = {
        color: 'black',
        fontSize: '10px',
        textTransform: 'uppercase',
        fontFamily: "'Vinimark-Diatype', sans-serif",
        fontWeight: 600,
        marginBottom: 0,
    };

    document.title = "Vinimark | International Team";

    // Apply smooth scroll behavior on mount
    useEffect(() => {
        document.documentElement.style.scrollBehavior = 'smooth';
        return () => {
            document.documentElement.style.scrollBehavior = 'auto';
        };
    }, []);

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            width: '100%',
            // overflow: 'hidden'
        }}>

        <div className="header-container">
                {isAtTop ? <HeaderWhite /> : <Header />}
            </div>
            <div
                style={{
                    backgroundImage: `url(${hero})`,
                    width: '100vw',
                    height: windowWidth > 835 ? '100vh' : '90vh',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    display: 'flex',
                    alignItems: 'flex-start',
                }}
            >
                <div style={containerStyle}>
                    <div style={textStyle}>Global Reach</div>
                    <a style={linkStyleWhite} href="#content">Read more</a>
                </div>
            </div>

            <div
                style={{
                    display: 'flex',
                    flexDirection: window.innerWidth > 835 ? 'row' : 'column',
                    alignItems: 'left',
                    width: '100vw',
                    gap: '20px',
                    scrollMarginTop: '100px',
                    marginTop: '60px',
                }}
                id="content"
            >
                <div style={{flex: 1, width: '100%',}}>
                    <div
                        style={{
                            display: 'flex',
                            alignContent: "flex-end",
                            justifyContent: 'flex-end',
                            width: '100%',
                        }}
                    >
                        <p style={{
                            textAlign: windowWidth > 575 ? 'right' : 'left',
                            textTransform: "uppercase",
                            fontSize: '20px !important',
                            paddingLeft: windowWidth > 835 ? '0' : '20px',
                            paddingRight: windowWidth > 835 ? '24px' : '20px',
                            marginBottom: '0',
                            width: windowWidth > 575 ? '70%' : '100%',
                            lineHeight: '26px',
                            marginRight: '24px',
                            fontWeight: 300,
                        }}
                        className='left-text'>
                            "To champion South African wine, and the people who make it possible."
                        </p>
                    </div>
                </div>

                <div style={{ flex: 1, textAlign: 'left', marginBottom: windowWidth > 575 ? '100px' : '26px', marginLeft: '26px'}}>
                    <div style={{width: windowWidth > 575 ? '70%': '90%', marginRight: windowWidth > 575 ? '0px' : '24px'}}>
                        <p style={{fontSize: '13px', lineHeight: '16.9px', fontWeight: 600}}>
                            INTERNATIONAL
                        </p>
                        <p style={{fontSize: '13px', lineHeight: '16.9px', fontWeight: 400 }}>
                            We are one of South Africa’s leading premium wine exporters, proudly connecting exceptional wines with discerning markets in over 80 countries. Our international team brings deep experience, market intelligence, and a hands-on approach to everything we do, working closely with a core selection of brands to represent and build lasting success, both for the brands and for South African wines as a category.
                        </p>
                        <p style={{fontSize: '13px', lineHeight: '16.9px', fontWeight: 400 }}>
                            We represent some of South Africa’s most iconic and emerging wine brands: Krone, Robertson Winery, Reyneke, Kasteelberg, Barista, and Vilafonté, including Seriously Old Dirt, among them. Our strength lies in relationships of trust with our route-to-market partners, built over many years by presenting a quality portfolio that, through tailored strategies, delivers consistent value to their businesses.
                        </p>
                        <p style={{fontSize: '13px', lineHeight: '16.9px', fontWeight: 400 }}>
                            Working collaboratively with our brand and international partners, we craft strategic brand journeys and implement targeted, market-specific campaigns, ensuring each wine reaches its ideal audience, wherever they are in the world.
                        </p>
                        {/*<p style={{fontSize: '13px', marginBottom: 0 }}>*/}
                        {/*    <a style={linkStyle} href="/">*/}
                        {/*        Download Credit Application*/}
                        {/*    </a>*/}
                        {/*</p>*/}
                        <p style={{fontSize: '13px', marginBottom: 0 }}>
                            <a style={linkStyle} href="mailto:VeroniqueC@vinimark.co.za?subject=Vinimark%20International%20Sales%20Team%20Enquiry">
                                Contact our international sales team
                            </a>
                        </p>
                    </div>


                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Export;
